<template>
  <v-container>
    <v-row v-if="!hideBarDisplay">
      <v-col class="mx-0 px-0 container1">
        <v-card
          class="header"
          :class="{ sticky: isSticky }"
          width="100%"
          height="140px"
          style="border-radius: 0px"
        >
          <BarDisplay :isSticky="isSticky" />
        </v-card>
      </v-col>
    </v-row>

    <!-- ========== ========== Hidden Box ========== ========== -->
    <v-row :style="{ 'margin-top': hideBarDisplay ? '0px' : '136px' }"></v-row>

    <ShortcutMenu />

    <v-row>
      <v-col cols="12">
        <div v-for="(item, index) in listModule" :key="index">
          <ContainerWidget
            :site="site"
            :moduleWidget="item"
            :loadedModule="loadedModule[item]"
            :getBannerSlide="getBannerSlide"
            :totalRequest="totalRequest"
            :dataFriendRecommend="dataFriendRecommend"
            :cardTitleFriend="cardTitleFriend"
            :dataMissionComing="dataMissionComing"
            :dataMission="dataMission"
            :rewardItem="rewardItem"
            :dataBlog="dataBlog"
            :dataGamification="dataGamification"
            @onClick="handleClickContainer"
            @getHotReward="getHotReward"
            @addFriend="addFriend"
          />
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogPopup"
      persistent
      class="container2"
      max-width="450"
    >
      <v-card flat class="rounded-0">
        <a :href="dataPopup.url" target="_blank">
          <v-img style="z-index: 0" :src="dataPopup.image_url"> </v-img>
        </a>
      </v-card>
      <v-card class="btn-close mt-5 mx-auto" color="transparent">
        <v-container>
          <v-row class="justify-center">
            <v-col cols="12" class="text-center font-weight-bold">
              <v-btn
                class="text-center"
                @click="closeDialogPopup"
                fab
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogBirthdayGift"
      persistent
      class="container2"
      max-width="450"
    >
      <v-card
        flat
        class="rounded-0 text-center"
        :style="{
          background: `radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 40%, ${site.color} 100%)`,
        }"
      >
        <v-card-title class="text-title d-flex justify-end pa-0">
          <v-btn
            class="ma-2"
            fab
            dark
            x-small
            color="white"
            @click="closeDialogBirthdayGift"
          >
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          style="z-index: 0; margin-top: -20px"
          :src="require('@/assets/images/hbd.png')"
        >
        </v-img>
        <div
          style="
            background: rgba(255, 255, 255, 0.5);
            border-radius: 25px;
            margin: 10px 20px 10px 20px;
            padding: 8px;
          "
        >
          <v-card-title
            class="text-center text-title mb-0 pt-3 pa-2 mx-auto d-block"
          >
            {{ $t("happyBirthMonth") }} {{ customer.name }}
            {{ customer.surname }} 🎉
          </v-card-title>

          <v-card-text class="text-center text-body-1 mb-0 pb-0">
            {{ $t("happyBirthMonthWish") }}
          </v-card-text>
        </div>

        <v-card-actions class="justify-center pa-4">
          <v-btn
            elevation="2"
            class="text-center"
            @click="goToBirthdayGift()"
            rounded
            color="white"
          >
            {{ $t("claimSpecialGift") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-show="site.is_scan"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="openDialogScan()"
      >
        <v-icon>mdi-qrcode-scan</v-icon>
      </v-btn>
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <DialogScan
      :dialogScan="dialogScan"
      @closeDialogScan="dialogScan = false"
      @onScanSuccess="handleScanSuccess"
    />

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />

    <DialogRewardConfirm
      :showDialog="showPopupAlertWelcomeReward"
      :rewardData="null"
      :rewardItem="customer.reward_welcome"
      :userAddress="null"
      :detail="null"
      type="welcomeReward"
      @confirm="updateViewWelcomeReward()"
    />
    <!--  -->
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { setTimeout } from "timers";
import BarDisplay from "@/components/barDisplay.vue";
import AxiosBackend from "@/config/backend-service";
import DialogScan from "@/components/activity/dialogScan.vue";
import ContainerWidget from "@/components/widget/container.vue";
import { getCustomFingerprinting } from "../../config/general-function";
import FloatPanel from "@/components/floatPanel.vue";
import DialogRewardConfirm from "@/components/dialogRewardConfirm.vue";
import ShortcutMenu from "../../components/shortcutMenu.vue";

export default {
  inject: ["isAppLoading"],
  name: "mainPage",
  components: {
    BarDisplay,
    DialogScan,
    ContainerWidget,
    FloatPanel,
    DialogRewardConfirm,
    ShortcutMenu,
  },
  data: () => ({
    dialogScan: false,
    dialogFloatPanel: false,
    fab: true,
    isSticky: false,
    model: null,
    url: "",
    drawer: false,
    group: null,
    slides: [],
    interval: 3000,
    dialogPopup: false,
    dataPopup: "",
    listMission: [],
    imgAds: "",
    dataDialog: "",
    dialog: false,
    itemFevorite: "",
    dialogFevorite: false,
    directUrl: "",
    dataPopupAll: [],
    dataItems: [],
    clickBannerAnounce: 0,
    festivalImage: "",
    rewardItem: [],
    item: "",
    dialogAddFavorite: false,
    dialogDeleteFavorite: false,
    dialogDetail: false,
    dialogBirthdayGift: false,
    dataAddress: [],
    dataMissionComing: [],
    dataMission: [],
    dataBlog: [],
    dataFriendRecommend: [],
    dataGamification: [],
    cardTitleFriend: [],
    totalRequest: 0,
    listModule: [
      "banner",
      "friend",
      "activity_coming",
      "activity_recommend",
      "reward",
      "blog",
      "game",
    ],
    loadedModule: {
      banner: true,
      friend: true,
      activity_coming: true,
      activity_recommend: true,
      reward: true,
      blog: true,
      game: true,
    },
    hideBarDisplay: false,
    showPopupAlertWelcomeReward: false,
  }),
  async created() {
    this.isAppLoading(true);
    await this.getDataAll();
    let code = localStorage.getItem("code");
    if (code) {
      // this.dialogScan = true;
    } else {
      this.isAppLoading(false);
    }
    this.$store.dispatch("banner/getBannerSlide");
    this.$store.dispatch("banner/getBannerAds", "main");
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.getBannerAds) {
      this.imgAds = this.getBannerAds.image_url;
      this.directUrl = this.getBannerAds;
    }

    setTimeout(() => {
      this.initFingerprintJS();
      // this.sendFingerPrinting();
      this.checkAlert();
    }, 2000);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkItemIsAvailable(item) {
      if (item.number_of_items == 0) {
        return false;
      } else {
        return true;
      }
    },
    checkExpireTime(time) {
      if (moment().isAfter(time, "day")) {
        return false;
      } else {
        return true;
      }
    },
    checkExpire(value) {
      if (moment().isAfter(value, "day")) {
        return this.$t("expireTime");
        // return 'hi'
      } else {
        return (
          this.$t("expireDateUse") +
          ` ${moment(value.split(" ")[0]).format("D MMMM YY")}`
        );
      }
    },
    async initFingerprintJS() {
      try {
        const fpPromise = window.FingerprintJS.load();
        fpPromise.then((fp) => {
          fp.get().then((result) => {
            const visitorId = result.visitorId;
            // console.log("Your fingerprint: ", visitorId);
            console.log(visitorId);
            // ส่งไป backend
          });
        });
      } catch (err) {
        console.log("initFingerprintJS", err);
      }
    },
    async sendFingerPrinting() {
      try {
        const body = await getCustomFingerprinting(true);
        const response = await AxiosBackend.post("track", { ...body });
        console.log(response);
      } catch (err) {
        console.log("sendFingerPrinting", err);
      }
    },

    // ========== ========== ========== ==========
    handleClickContainer(param) {
      if (param?.func == "clickBanner") {
        this.clickBanner(param?.param);
      } else if (param?.func == "goToFriendPage") {
        this.goToFriendPage(param?.param);
      } else if (param?.func == "goToListActivityComing") {
        this.goToListActivityComing(param?.param);
      } else if (param?.func == "goToListActivityRecommended") {
        this.goToListActivityRecommended(param?.param);
      } else if (param?.func == "goToRewardSoHot") {
        this.goToRewardSoHot(param?.param);
      } else if (param?.func == "goToNews") {
        this.goToNews(param?.param);
      } else if (param?.func == "goToGamification") {
        this.goToGamification(param?.param);
      }
    },
    goToFriendPage(type) {
      if (type == "request") {
        this.$router.push({ name: "friend-request" });
      } else if (type == "friend") {
        this.$router.push({ name: "friend-list" });
      } else if (type == "recommend") {
        this.$router.push({ name: "friend-recommend" });
      }
    },
    goToRewardSoHot() {
      this.$router.push({ name: "reward-so-hot" });
    },
    goToListActivityComing() {
      this.$router.push({ name: "activity-coming" });
    },
    goToListActivityRecommended() {
      this.$router.push({ name: "activity-recommended" });
    },
    goToBirthdayGift() {
      this.closeDialogBirthdayGift();
      this.$router.push({ name: "birthday-gift" });
    },
    goToNews() {
      this.$router.push({
        name: "all-blog",
      });
    },
    goToGamification() {
      this.$router.push({
        name: "gamification-all",
      });
    },
    clickBanner(slide) {
      if (slide.url != null) {
        window.open(slide.url, "_blank");
      }
    },
    // ========== ========== ========== ==========

    handleScroll() {
      // Change header appearance based on scroll position
      this.isSticky = window.scrollY > 65;
    },
    openDialogScan() {
      this.dialogScan = true;
    },
    handleScanSuccess(param) {
      const mission_type = param.mission_type;
      const employee_mission = param.employee_mission;
      if (mission_type == "quest-tracking") {
        this.$router.push({
          name: "my-mission-detail",
          params: { id: employee_mission.id },
        });
        return;
      }
    },
    addFriend(item) {
      Axios.post("friend/addFriend", {
        user_id: item.id,
      })
        .then(({ data }) => {
          this.$swal.fire({
            icon: "success",
            text: data.message,
            showConfirmButton: false,
            timer: 2000,
          });
          this.dataFriendRecommend = this.dataFriendRecommend.filter(
            (friend) => friend.id !== item.id
          );
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    closeDialogBirthdayGift() {
      Axios.post("ackBirthdayGift").then(({ data }) => {
        if (data.status == "success") {
          this.dialogBirthdayGift = false;
        }
      });
    },
    closeDialogPopup() {
      this.clickBannerAnounce = this.clickBannerAnounce + 1;
      if (this.clickBannerAnounce < this.dataPopupAll.length) {
        this.dataPopup = this.dataPopupAll[this.clickBannerAnounce];
      } else {
        this.dialogPopup = false;
      }
      Axios.post("site/readBannerPopup")
        .then(() => {
          //
        })
        .catch((err) => {
          console.log("readBannerPopup", err);
        });
    },

    async getDataAll() {
      try {
        const showPopupBirthdayGift = this.site?.show_birthday_gift_popup;
        this.dialogBirthdayGift = showPopupBirthdayGift;
        const home_layout = this.site?.home_layout;
        if (Array.isArray(home_layout)) {
          let list = [...home_layout];
          this.listModule = [...list];
        }
        this.getHotReward();
        this.getMissionRecommend();
        this.getMissionComing();
        // await this.getFriendRecommend();
        this.getBlog();
        this.getBannerPopup();
        this.getGamification();
      } catch (error) {
        console.log("error :>> ", error);
        this.$router.push({ name: "check-login" });
      }
    },

    // ========== ========== Main View ========== ==========
    async getHotReward() {
      this.loadedModule.reward = false;
      try {
        const response = await Axios.get("reward/listHotReward?limit=10");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.rewardItem = data.data;
        }
      } catch (err) {
        console.log("getHotReward", err);
      }
      this.loadedModule.reward = true;
    },
    async getMissionRecommend() {
      this.loadedModule.activity_recommend = false;
      try {
        const response = await Axios.get("mission/listMissionRecommend?limit=10");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataMission = data.data;
        }
      } catch (err) {
        console.log("getMissionRecommend", err);
      }
      this.loadedModule.activity_recommend = true;
    },
    async getMissionComing() {
      this.loadedModule.activity_coming = false;
      try {
        const response = await Axios.get("mission/listMissionHot?limit=10");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataMissionComing = data.data;
        }
      } catch (err) {
        console.log("getMissionComing", err);
      }
      this.loadedModule.activity_coming = true;
    },
    async getFriendRecommend() {
      this.loadedModule.friend = false;
      try {
        const response = await Axios.get("friend/recommendFriend");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataFriendRecommend = data.user;
          this.cardTitleFriend = data.card_profile?.split(",");
          this.totalRequest = data.total_request;
        }
      } catch (err) {
        console.log("getFriendRecommend", err);
      }
      this.loadedModule.friend = true;
    },
    async getBlog() {
      this.loadedModule.blog = false;
      try {
        const response = await Axios.get("site/getBlog");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataBlog = data;
        }
      } catch (err) {
        console.log("getBlog", err);
      }
      this.loadedModule.blog = true;
    },
    async getBannerPopup() {
      this.loadedModule.banner = false;
      this.dataPopup = "";
      this.dataPopupAll = [];
      try {
        const response = await Axios.get("site/getBannerPopup");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          if (Array.isArray(data)) {
            this.dataPopup = data[0];
            this.dataPopupAll = data;
            this.dialogPopup = true;
          }
        }
      } catch (err) {
        console.log("getBannerPopup", err);
        // this.$swal.fire({
        //   icon: "error",
        //   text: err.response.data.message,
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
      }
      this.loadedModule.banner = true;
    },
    async getGamification() {
      this.loadedModule.game = false;
      try {
        const response = await Axios.get("gamification/getGamification?limit=10");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.dataGamification = data;
        }
      } catch (err) {
        console.log("getGamification", err);
      }
      this.loadedModule.game = true;
    },

    // ========== ========== ========== ==========
    async checkAlert() {
      // ========== ========== Profile ========== ==========
      const _profileData = this.getCustomer || {};
      if (
        _profileData.alert_welcome_reward == false &&
        _profileData.reward_welcome?.length > 0
      ) {
        this.showPopupAlertWelcomeReward = true;
      }
    },
    getEmployeeInAppNoti() {
      let user_ = this.$store?.state?.defaultSystem?.customer;
      if (user_) {
        Axios.get("getEmployeeInAppNoti")
          .then((res) => {
            const dataResponse = res?.data;
            if (dataResponse?.status == "success") {
              const data = dataResponse.data;
              const message = data.message;
              alert(message);
            }
          })
          .catch((err) => {
            console.log("getEmployeeInAppNoti", err);
          });
      }
    },
    updateViewWelcomeReward() {
      Axios.get("confirmWelcomeReward")
        .then((res) => {
          const dataResponse = res?.data;
          if (dataResponse?.status == "success") {
            this.showPopupAlertWelcomeReward = false;
          }
        })
        .catch((err) => {
          console.log("confirmWelcomeReward", err);
        });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    ...mapGetters("banner", ["getBannerSlide", "getBannerAds"]),
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
    swiperStyles() {
      return {
        "--swiper-pagination-color": this.site.color,
        // "--swiper-pagination-bullet-inactive-color": "#999999",
        // "--swiper-pagination-bullet-inactive-opacity": "1",
        // "--swiper-pagination-bullet-size": "16px",
        // "--swiper-pagination-bullet-horizontal-gap": "6px"
      };
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style lang="scss" scoped>
/* .expire-date {
  line-height: 1.3;
  position: absolute;
  bottom: 0px;
}
*/
.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 5px;
}
.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.custom-header {
  margin-top: -130px;
  margin-bottom: -55px;
}
@media only screen and (min-width: 768px) {
  .custom-header {
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

.user-img {
  width: 50px;
}

/* .swiper {
  height: 220px;
  width: 100%;
}

.swiper-slide {
  display: flex;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 70%;
}

.swiper-slide img {
  width: 80%;
  object-fit: contain;
} */

.swiper-pagination-bullets {
  bottom: -6px;
}

.swiper {
  width: 100%;
  padding-bottom: 20px;
}

.swiper-slide {
  display: flex;
  // border-radius: 10px !important;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-size: cover;
  width: 300px;
  height: 160px;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  // object-fit: contain;
  object-fit: cover;
}

@media only screen and (min-width: 600px) {
  .swiper-slide {
    width: 550px;
    height: 160px;
  }
}

@media only screen and (min-width: 960px) {
  .swiper-slide {
    width: 750px;
    height: 240px;
  }
}

@media only screen and (min-width: 768px) {
  .sticky {
    position: absolute !important;
    top: 0;
    width: 100%;
    background-color: transparent; /* Background color when sticky */
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Box shadow when sticky */
  }
}
.fixed-row {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.container1 {
  position: relative;
}

.header-container {
  transition: background-color 0.3s, box-shadow 0.3s;
}

.header {
  background-color: transparent; /* Initial background color */
  box-shadow: none; /* Initial box shadow */
  position: absolute;
  z-index: 10;
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: transparent; /* Background color when sticky */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1); /* Box shadow when sticky */
}
</style>

<style scope>
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}

.v-btn__content {
  display: flex;
  flex-direction: column;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 80px;
  min-width: 95px;
  border-radius: 10px;
}

.bar-image {
  height: 210px;
  font-size: 14px;
}

.v-btn-toggle--group > .v-btn.v-btn {
  background-color: white !important;
  border-color: transparent;
}
.v-btn--absolute.v-btn--top,
.v-btn--fixed.v-btn--top {
  top: 3px;
}
.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: 5px;
}

.v-slide-group__content {
  justify-content: start !important;
}
.container2 {
  position: relative;
}
.btn-close {
  position: absolute;
  margin-bottom: -100px;
  z-index: 888;
  right: 0;
}
.div-popup {
  max-width: "800px";
}
</style>
